<template>
  <div class="van-hairline--bottom">
    <van-field
      :label="label"
      :value="value"
      :border="false"
      :placeholder="placeholder"
      readonly
      :is-link="isLink"
      @focus="onFocus"
      @click="onClick"
    />
    <p v-if="showMsg" class="fz12 red" style="padding: 0px 16px 10px 16px">{{msg}}</p>
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        :type="type"
        :value="defaultValue"
        :min-date="minDate"
        :max-date="maxDate"
        :min-hour="minHour"
        :max-hour="maxHour"
        :filter="filter"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "date-field",
  data() {
    return {
      showDatePicker: false
    };
  },
  props: {
    type: {
      type: String,
      default: "date"
    },
    value: {
      type: String,
      default: function() {
        return moment().format("YYYY-MM-DD");
      }
    },
    label: {
      type: String,
      default: "日期"
    },
    placeholder: {
      type: String,
      default: "必填，选择日期"
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    minValue: {
      type: String,
      default: ""
    },
    maxValue: {
      type: String,
      default: ""
    },
    isLink: {
      type: Boolean,
      default: true
    },
    showMsg: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: ''
    },
  },
  computed: {
    defaultValue() {
      if (this.type === "time") {
        return this.value;
      } else {
        return new Date(this.value);
      }
    }
  },
  methods: {
     filter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 5 === 0);
      }
      return options;
    },
    onFocus() {
      document.activeElement.blur();
    },
    onClick() {
      this.showDatePicker = true;
    },
    confirm(value) {
      this.showDatePicker = false;
      let returnVale="";
      if (this.type === "date") {
        returnVale = moment(value).format("YYYY-MM-DD");
      } else {
        returnVale = value;
      }
      if(this.minValue && returnVale<this.minValue){
        this.$toast(this.label+"不能早于 "+this.minValue);
        return false;
      }
      if(this.maxValue && returnVale>this.maxValue){
        this.$toast(this.label+"不能超过 "+this.maxValue);
        return false;
      }
      this.$emit("input", returnVale);
    },
    cancel() {
      this.showDatePicker = false;
    }
  },
  watch: {
    showDatePicker(val) {
      this.$emit("showPopupChange", val);
    }
  }
};
</script>
